import { createSelector } from 'reselect';
import ReportByDayComponent from '../../../../utils/ReportByDayComponent/ReportByDayComponent';
import resolveMetricsConfig from '../../../../helpers/reportMetrics';

const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || {};
const parameters = (state) => state.statistics.data.parameters || {};
const report = (state) => state.serverStorage.store.reportByDay || state.serverStorage.store.report;
const reportUtils = ReportByDayComponent.utils;

const buildMetricsConfig = (parameters = {}, location = {}, reportMetricsValue = '') =>
    resolveMetricsConfig(parameters, location, reportMetricsValue, reportUtils);

export const getCheckedKeys = createSelector(
    parameters,
    location,
    report,
    (parameters, location, report) => {
        return buildMetricsConfig(parameters, location, report?.metrics).keys;
    }
);

export const getMetrics = createSelector(
    parameters,
    location,
    report,
    (parameters, location, report) => {
        return buildMetricsConfig(parameters, location, report?.metrics).binary;
    }
);

export const mainSelector = createSelector(
    report,
    (report) => {
        return reportUtils.getMultiLevelHeaderNames();
    }
);
